import { Component, Input } from '@angular/core'
import { AnchorService } from 'dmmp-services'

@Component({
  selector: 'dmmp-mobile-menu-header',
  templateUrl: './mobile-menu.component.html',
})
export class MobileMenuComponent {

  @Input() data: any
  @Input() identifier: string
  @Input() medias: []
  menuIsOpened = false

  constructor(public anchorService: AnchorService) {
  }

  closeAndOpenMenu() {
    this.menuIsOpened ? this.menuIsOpened = false : this.menuIsOpened = true
  }
}
